import {roles} from "../../../../../resources/js/plugins/utils";
import {hasLotteryEnabled} from '~/plugins/config'
const packageId = 'lottery'
import {hasPermissionByRouteName} from "../../../../../resources/js/router/permissions";

export const navItems = [
    hasLotteryEnabled() && hasPermissionByRouteName(`admin.lottery.index`) ? {
        icon: 'mdi-ticket',
        title: 'Lottery',
        roles: [roles.ADMIN, roles.MANAGER, roles.SUPERVISOR],
        posRoles: [roles.ADMIN, roles.MANAGER, roles.SUPERVISOR],
        hasChildren: true,
        children: [
            !hasPermissionByRouteName(`admin.${packageId}.dashboard`) ? null : {
                to: {name: `admin.${packageId}.dashboard`},
                title: 'Panel',
            },
            !hasPermissionByRouteName(`admin.${packageId}.lottery-banks`) ? null : {
                to: {name: `admin.${packageId}.lottery-banks`},
                title: 'Lotteries',
            },
            !hasPermissionByRouteName(`admin.${packageId}.results`) ? null : {
                to: {name: `admin.${packageId}.results`},
                title: 'Results',
            },
            !hasPermissionByRouteName(`admin.${packageId}.voucher-tickets`) ? null : {
                to: {name: `admin.${packageId}.voucher-tickets`},
                title: 'Voucher Tickets',
            },
            !hasPermissionByRouteName(`admin.${packageId}.tickets-in-process`) ? null : {
                to: {name: `admin.${packageId}.tickets-in-process`},
                title: 'Tickets in process',
            },
            !hasPermissionByRouteName(`admin.${packageId}.won-tickets`) ? null : {
                to: {name: `admin.${packageId}.won-tickets`},
                title: 'Winning Tickets',
            },
            !hasPermissionByRouteName(`admin.${packageId}.past-tickets`) ? null : {
                to: {name: `admin.${packageId}.past-tickets`},
                title: 'Past Tickets',
            },
            !hasPermissionByRouteName(`admin.${packageId}.tickets`) ? null : {
                to: {name: `admin.${packageId}.tickets`},
                title: 'Plays',
            },
            !hasPermissionByRouteName(`admin.${packageId}.configuration`) ? null : {
                to: {name: `admin.${packageId}.configuration`},
                title: 'Configuration',
            },
        ].filter(item => !!item)
    }: null,
].filter(item => !!item)
